import { atom, atomFamily, RecoilState, SerializableParam } from 'recoil'

export type TRecoilHelperProps = {
  prefix: string
  key: string
  default?: any
}

export function createAtom<T>(props: TRecoilHelperProps): RecoilState<T> {
  const { prefix, key, default: defaultValue, ...rest } = props
  return atom<T>({
    key: `${prefix}/${key}`,
    default: defaultValue,
    ...rest,
  })
}

export function createAtomFamily<T, P extends SerializableParam = string>(
  props: TRecoilHelperProps,
): (p: P) => RecoilState<T> {
  const { prefix, key, default: defaultValue, ...rest } = props
  return atomFamily<T, P>({
    key: `${prefix}/${key}`,
    default: defaultValue,
    ...rest,
  })
}
